import { BaseApiService } from '@/shared/api/services/base.service';

export interface OnboardingSlideAttributes {
  index: number;
  title: string;
  description: string;
  overlay_text: string | null;
  image_url: string;
}

export interface OnboardingSlide {
  type: 'onboarding-slide';
  id: string;
  attributes: OnboardingSlideAttributes;
}

interface OnboardingSlidesResponse {
  data: OnboardingSlide[];
}

class OnboardingService extends BaseApiService {
  async getSlides(): Promise<OnboardingSlide[]> {
    const response = await this.httpGet<OnboardingSlidesResponse>(
      '/v1/onboarding/slides'
    );
    return response.data;
  }

  /**
   * Mark the onboarding carousel as auto-shown for this account. The server
   * latches `should_show_onboarding` to false forever on first call, so the
   * slides auto-show at most once per account (no re-show on later logins).
   *
   * Fire-and-forget and advisory: returns 204 with no body, never blocks UI,
   * and swallows failures (a lost mark only risks the slides auto-showing one
   * extra time). MUST be called only on the auto-show path — manual Help
   * replays deliberately skip it.
   */
  async markOnboardingShown(): Promise<void> {
    try {
      await this.post<void>('/v1/user/onboarding-shown');
    } catch {
      // Advisory — a lost mark just risks one extra auto-show. Never surface.
    }
  }
}

export const onboardingService = new OnboardingService();
